import React, { useState, useEffect } from "react";
import { TextField, Button, Box } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";

const StepPasswordSetup = ({
  password,
  confirmPassword,
  setPassword,
  setConfirmPassword,
  handlePasswordSetup,
  loading,
}) => {
  const [errors, setErrors] = useState({ password: "", confirmPassword: "" });

  const validate = () => {
    const newErrors = { password: "", confirmPassword: "" };

    if (!password) {
      newErrors.password = "Password is required";
    } else if (password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Confirm Password is required";
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);
    return !newErrors.password && !newErrors.confirmPassword;
  };

  const handleSubmit = () => {
    if (validate()) {
      handlePasswordSetup();
    }
  };

  useEffect(() => {
    // clear errors when typing
    setErrors({ password: "", confirmPassword: "" });
  }, [password, confirmPassword]);

  return (
    <>
      <Box textAlign="center" mb={1}>
        <LockIcon fontSize="large" color="primary" />
      </Box>
      <h2>Set your password</h2>

      <TextField
        fullWidth
        label="Password"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        error={!!errors.password}
        helperText={errors.password}
        margin="normal"
        size="small"
      />
      <TextField
        fullWidth
        label="Confirm Password"
        type="password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        error={!!errors.confirmPassword}
        helperText={errors.confirmPassword}
        margin="normal"
        size="small"
      />

      <Button
        variant="contained"
        fullWidth
        sx={{ mt: 2 }}
        onClick={handleSubmit}
      >
        {loading ? "Loading..." : "Continue"}
      </Button>
    </>
  );
};

export default StepPasswordSetup;
